export const Separator = () => (
  <div className="p-3">
    <hr className="border-primary h-[1px] overflow-hidden border-t" />
  </div>
);
